
const paths = {
    home: "/",
    movieDetail: "/movie",
    seriesDetail: "/tv"
}

export default paths;